module.exports = __webpack_public_path__ + "static/foodtruckOnline-eb56b504300f7456d26bbd8adb856162.jpg";